import React from 'react';
import { useForm } from 'react-hook-form';
import FormButton from '../Form/FormButton';
import FormInput from '../Form/FormInput';

export interface Props {
  onSubmit: (data: any) => void;
  onForgetPassClick: () => void;
}

export default function LoginSignin(props: Props) {
  const { register, handleSubmit, errors } = useForm();

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <FormInput
        type="email"
        name="email"
        placeholder="Correo electrónico"
        autoComplete="username"
        error={
          errors.email?.type === 'required'
            ? 'Debes indicar un correo electrónico.'
            : errors.email?.type === 'pattern'
            ? 'Debes indicar un correo electrónico válido.'
            : null
        }
        inputRef={register({
          required: true,
          pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
        })}
      />
      <FormInput
        autoComplete="current-password"
        type="password"
        name="password"
        placeholder="Contraseña"
        error={
          errors.password?.type === 'required'
            ? 'Contraseña obligatoria.'
            : errors.password?.type === 'minLength'
            ? 'Tu contraseña debe tener al menos 8 caracteres.'
            : null
        }
        inputRef={register({ required: true, minLength: 8 })}
      />

      <FormButton variant="text" onClick={props.onForgetPassClick}>
        Olvidé mi contraseña
      </FormButton>

      <FormButton type="submit" variant="contained" fullWidth>
        Entrar
      </FormButton>
    </form>
  );
}
